import { Button } from 'primereact/button'
import { useEffect, useState } from 'react'
import Upsert from '../../components/form/Upsert'
import Modal from '../../components/popup/Modal'

const CapPhat = (props) => {
  const { submit, data } = props
  const [visible, setVisible] = useState(false)
  const [values, setValues] = useState({})
  const [error, setError] = useState({})
  const toggle = () => setVisible(!visible)

  useEffect(() => {
    setError({})
    setValues({})
  }, [visible])

  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          if (toggle) toggle()
        }}
      />
      <Button
        onClick={() => {
          const newError = {}
          if (!values.ngayCapPhat) {
            newError.ngayCapPhat = 'Ngày cấp không được để trống'
          }
          if (!values.nguoiCapPhat) {
            newError.nguoiCapPhat = 'Người cấp không được để trống'
          }
          setError(newError)
          if (Object.keys(newError).length > 0) {
            return
          }
          if (submit) {
            submit(data, values)
          }
          toggle()
        }}
        label="Lưu"
      />
    </div>
  )
  return (
    <>
      <Modal
        visible={visible}
        toggle={toggle}
        header="Cấp phát chứng nhận tốt nghiệp"
        footer={footer}
      >
        <div className="mt-4">
          <Upsert
            fields={['nguoiCapPhat', 'ngayCapPhat']}
            name={{ nguoiCapPhat: 'Người cấp phát', ngayCapPhat: 'Ngày cấp phát' }}
            types={{ ngayCapPhat: 'date' }}
            values={values}
            setValues={setValues}
            error={error}
            setError={setError}
          />
        </div>
      </Modal>
      <Button
        icon="pi pi-send"
        className="p-button-rounded p-button-success mr-2"
        onClick={() => {
          // setOneData(data)
          toggle()
        }}
        tooltip="Cấp phát"
        tooltipOptions={{ position: 'top' }}
      />
    </>
  )
}

export default CapPhat
